import { useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import { easing } from 'maath'

export default function TransitionMaterialFree({ transitionColor, transitionTime = 0.25, ...props }) {
  const materialRef = useRef()

  useFrame((_, delta) =>
    easing.dampC(materialRef.current.color, transitionColor, transitionTime, delta)
  )

  return <meshPhysicalMaterial ref={materialRef} {...props} />
}
